export const frShops = {
    // SHOPS

    'shops.filters.categories.select.title': 'Catégorie',
    'shops.title': 'Centres',

    'shops.list.pageTitle': 'Centres',
    'shops.list.sectionTitle': 'Centres',
    'shops.list.emptyLabel': 'Aucun centre pour le moment.',
    'shops.list.actions.addShop': 'Ajouter un centre',
    'shops.list.actions.importExcel': 'Import Excel',
    'shops.list.actions.exportExcel': 'Export Excel',
    'shops.list.item.floatingLabelTitle': 'Nom',
    'shops.list.item.floatingLabelCode': 'Code',
    'shops.list.item.floatingLabelPath': 'Chemin',
    'shops.list.item.floatingLabelCategory': 'Catégorie',
    'shops.list.item.floatingLabelParentName': 'Secteur',
    'shops.list.item.accountant': 'Responsable',
    'shops.list.item.ghost': 'Invisible',

    // SHOPS >> FILTERS

    'shops.filters.categories.1': 'Catégorie 1',
    'shops.filters.categories.2': 'Catégorie 2',
    'shops.filters.categories.3': 'Catégorie 3',
    'shops.filters.categories.4': 'Catégorie 4',
    'shops.filters.categories.name': 'Catégorie',
    'shops.filters.categories.filterLabelName': 'Catégorie: ',
    'shops.filters.categories.short.1': '1',
    'shops.filters.categories.short.2': '2',
    'shops.filters.categories.short.3': '3',
    'shops.filters.categories.short.4': '4',
    'shops.filters.shopTypeFilter.name': 'Type de centre',
    'shops.filters.shopTypeFilter.filterLabelName': 'Type de centre: {type}',
    'shops.filters.shopTypeFilter.All': 'Tous',
    'shops.filters.shopTypeFilter.Normal': 'Normal',
    'shops.filters.shopTypeFilter.Ghost': 'Invisible',

    'results.filters.shop.button.label': 'Centre',

    // SHOPS >> DETAILS
    'shops.details.pageTitle': 'Détails centre',

    'shops.details.create': 'Détails centre',
    'shops.details.generalInfo': 'INFORMATIONS GÉNÉRALES',

    'shops.date_and_state.title': 'Date de dernière mise à jour',
    'shops.date_and_state.format': '{date} - {state}',
    'shops.access_state.Ok': 'À Jour',
    'shops.access_state.NeedUpdate': 'En attente de màj',
    'shops.access_state.MandatoryUpdate': 'Bloqué',

    'shops.details.additionalRoles': 'RÔLES SUPPLÉMENTAIRES',
    'shops.details.detailsInfo':
        'Pas de centre enfant pour le moment. Pour en ajouter, rendez-vous dans l’onglet « Centres » où vous pourrez affecter des secteurs parents.',
    'shops.details.actions.save': 'Enregistrer',
    'shops.details.actions.removeShop': 'Supprimer le centre',
    'shops.details.actions.previous': 'Centres',
    'shops.details.dialog.title': 'Suppression de centre',
    'shops.details.dialog.content': 'Êtes-vous sûr de vouloir supprimer ce centre ?',
    'shops.details.dialog.validateLabel': 'Supprimer',
    'shops.details.dialog.cancelLabel': 'Annuler',
    'shops.details.input.name': 'Saisissez ici le nom du Centre *',
    'shops.details.input.code': 'Saisissez ici le code du Centre *',
    'shops.details.input.floatingLabelName': 'Nom',
    'shops.details.input.floatingLabelCode': 'Code',
    'shops.details.select.parent.sectionTitle': 'tot',
    'shops.details.select.parent.floatingLabel': 'Secteur parent :',
    'shops.details.select.parent.title': 'Choisir un secteur parente *',
    'shops.details.select.parent.listTitle': 'Choix du secteur parent',
    'shops.details.select.parent.listInputLabel': 'Chercher un secteur',
    'shops.details.select.parent.listCloseLabel': 'Fermer',
    'shops.details.select.user.floatingLabel': 'Responsable centre :',
    'shops.details.select.user.title': 'Nom du responsable',
    'shops.details.select.user.listTitle': 'Choix du responsable',
    'shops.details.select.user.listInputLabel': 'Chercher un responsable',
    'shops.details.select.user.listCloseLabel': 'Fermer',
    'shops.details.toggle.invisible.label': 'Centre invisible ?',

    'shops.details.roles.table.emptyLabel': "Il n'y a aucun rôle supplémentaire",
    'shops.details.roles.table.header.userInfo': 'Informations utilisateur',
    'shops.details.roles.table.header.role': 'Rôle supplémentaire',
    'shops.details.roles.add.role': 'Ajouter un rôle',
    'shops.details.roles.delete.dialog.title': 'Suppression de rôle',
    'shops.details.roles.delete.dialog.content':
        'Êtes-vous sûr de vouloir supprimer ce rôle ainsi que l’utilisateur siège assigné ?',
    'shops.details.roles.delete.dialog.cancel.label': 'Annuler',
    'shops.details.roles.delete.dialog.confirm.label': 'Supprimer',

    //USER ROLE
    'shops.details.roles.Manager': 'Responsable de centre',
    'shops.details.roles.SecondaryManager': 'Autre Responsable',
    'shops.details.roles.AdminTakeControl': 'Agir en tant que responsable',
    'shops.details.roles.GroupLeader': 'Animateur',
    'shops.details.roles.unknown': 'Inconnu',

    'shops.details.add.role.dialog.role.title': 'Choix du rôle',
    'shops.details.add.role.dialog.role.input.label': 'Chercher un rôle',
    'shops.details.add.role.dialog.role.close.label': 'Fermer',

    'shops.details.add.role.dialog.user.title': "Choix de l'utilisateur",
    'shops.details.add.role.dialog.user.input.label': 'Chercher un utilisateur',
    'shops.details.add.role.dialog.user.close.label': 'Fermer',

    // SHOPS >> CREATE
    'shops.create.pageTitle': 'Création centre',

    'shops.list.create': 'Création centre',
    'shops.create.actions.cancelCreation': 'Annuler la création',
    'shops.create.actions.addTheShop': 'Enregistrer',
    'shops.create.select.parent.floatingLabel': 'Secteur parent :',
    'shops.create.select.parent.title': 'Choisir un secteur parent *',
    'shops.create.select.parent.listTitle': 'Choix du secteur parent',
    'shops.create.select.parent.listInputLabel': 'Chercher un secteur',
    'shops.create.select.parent.listCloseLabel': 'Fermer',
    'shops.create.select.user.floatingLabel': 'Responsable centre :',
    'shops.create.select.user.title': 'Nom du responsable',
    'shops.create.select.user.listTitle': 'Choix du responsable',
    'shops.create.select.user.listInputLabel': 'Chercher un responsable',
    'shops.create.select.user.listCloseLabel': 'Fermer',
    'shops.create.input.name': 'Saisissez ici le nom du Centre *',
    'shops.create.input.code': 'Saisissez ici le code du Centre *',
    'shops.create.input.floatingLabelName': 'Nom',
    'shops.create.input.floatingLabelCode': 'Code',

    //TOAST
    'shops.import.success': 'Bravo! Centres importés avec succès',

    //ERRORS
    'toast.apiErrors.SHOPS_USER_DUPLICATED': 'Un utilisateur ne peut pas avoir plusieurs rôles',
};
